export default function Advertise() {

  return (

    <div className="container-narrow">

      <div className="card">

        <h1>Advertise with us</h1>

        <p>

          Hopeful Horizons NY provides a unique opportunity to connect with families and individuals seeking OPWDD services across New York State.

        </p>

        <p>

          Providers, agencies, and organizations may advertise services related to:

        </p>

        <ul>

          <li>Community Habilitation</li>

          <li>Respite services</li>

          <li>Transportation supports</li>

          <li>Recreational and community programs</li>

          <li>Professional services supporting individuals with developmental disabilities</li>

        </ul>

        <p>

          Advertising opportunities may include featured provider listings, activity promotion, and community resource visibility.

        </p>

        <p>

          For advertising inquiries, please contact us through the Contact page.

        </p>

      </div>

    </div>

  );

}